<ng-content></ng-content>
  <dx-resizable
  [ngClass]="compactMode?'not-show':''"
    id="gridContainer"
    [minWidth]="!compactMode?250:45"
    [maxWidth]="!compactMode?500:45"
    [keepAspectRatio]="true"
    [inputMode]="'overlap'"
    [handles]="handles.join(' ')"
    area=".dx-drawer-wrapper"
  >
    <!-- Kabuk canlandırma (02.10.2026): eski hâli
    <div class="menu-container" (click)="routeMain()">
      <dx-button
        id="modules-show"
        [ngClass]="!compactMode ? 'modules-btn' : 'modules-btn-hide'"
        icon="mediumiconslayout"
        (click)="showSelectModule()"
        [text]="!compactMode ? menuTitle : ''"
        [height]="32"
      ></dx-button>
    -->
    <div class="menu-container" [class.dar]="compactMode" (click)="routeMain()">
      <!-- Tüm Uygulamalar: seçili modülün ikon/rengiyle (bkz. menu-gorunum.ts) -->
      <button
        id="modules-show"
        type="button"
        class="modul-btn"
        [style.--r]="modulRenk"
        [title]="menuTitle"
        (click)="showSelectModule()"
      >
        <span class="modul-btn-ikon"><i class="dx-icon" [ngClass]="modulIkonSinif"></i></span>
        <ng-container *ngIf="!compactMode">
          <span class="modul-btn-ad">{{ menuTitle }}</span>
          <i class="dx-icon dx-icon-chevrondown modul-btn-ok"></i>
        </ng-container>
      </button>
      <!-- Açılır menü (16.10.2026, deneme): daraltılmışken ağaç/arama/favoriler yerine ikon şeridi + basamaklı pencereler.
           Geri almak: dk-acilir-menu.component.ts → ACILIR_MENU_AKTIF = false -->
      <dk-acilir-menu
        *ngIf="acilirGoster"
        [menu]="allMenuList || []"
        [favoriler]="(favlist$ | async) || []"
        (formSec)="acilirFormSec($event)"
        (favoriDegistir)="acilirFavoriDegistir($event)"
        (genislet)="menuyuGenislet.emit()"
      ></dk-acilir-menu>
      <dx-text-box #searchBox  class="menu-search-box"
    [class.gizli]="acilirGoster"
    mode="search"
    (onInput)="searchMenu($event)"
      [placeholder]="'Form Arama'"
      >
      <dxi-button
      location="after"
      name="clearBtn"
      [options]="clearBtnOptions"
      [tabindex]="-1"
      >
      </dxi-button>
      <dxi-button
      location="after"
      name="withChildBtn"
      [options]="withChildBtnOptions"
      [tabindex]="-1"
      >
      </dxi-button>
      <dxi-button
      location="after"
      name="collapseBtn"
      [options]="collapseBtnOptions"
      [tabindex]="-1"
      >
      </dxi-button>
    </dx-text-box>
        <dx-tree-view
          #treeview
          class="menu-list-treeview"
          [class.gizli]="acilirGoster"
          id="treeview"
          [items]="filteredMenuList || []"
          keyExpr="menuId"
          selectionMode="single"
          [focusStateEnabled]="true"
          expandEvent="click"
          [expandAllEnabled]="false"
          [noDataText]="!compactMode ? 'Lütfen Modül Seçiniz' : ''"
          (onItemClick)="onItemClick($event)"
          (onItemContextMenu)="treeViewItemContextMenu($event)"
          (onItemRendered)="onItemRendered($event)"
          width="100%"
          >
        </dx-tree-view>
      <div class="fav-area" [class.gizli]="acilirGoster">
        <!-- Kabuk canlandırma (02.10.2026): eski hâli
        <dx-button
          id="favorites-show"
          [ngClass]="!compactMode ? 'fav-btn' : 'fav-btn-hide'"
          icon="favorites"
          [text]="!compactMode ? 'Favorilerim' : ''"
          [hoverStateEnabled]="false"
          [height]="24"
        ></dx-button>
        ... favori dx-tree-view'de: [noDataText]="!compactMode ? 'Favorileriniz Boş' : ''"
        -->
        <div id="favorites-show" class="fav-bas">
          <span class="fav-yildiz"><i class="dx-icon dx-icon-favorites"></i></span>
          <ng-container *ngIf="!compactMode">
            <span>Favorilerim</span>
            <span class="fav-sayi" *ngIf="(favlist$ | async)?.length as sayi">{{ sayi }}</span>
          </ng-container>
        </div>
        <div class="fav-bos" *ngIf="!compactMode && (favlist$ | async)?.length === 0">
          <i class="dx-icon dx-icon-favorites"></i>
          <b>Henüz favori yok</b>
          <span>Bir forma sağ tıklayıp “Favorilere Ekle” deyin.</span>
        </div>
        <dx-tree-view
          #treeview
          id="treeview"
          class="fav-agac"
          [visible]="!!(favlist$ | async)?.length"
          [items]="(favlist$ | async) || []"
          keyExpr="menuId"
          selectionMode="single"
          [focusStateEnabled]="true"
          expandEvent="click"
          [expandAllEnabled]="false"
          [noDataText]="''"
          (onItemClick)="onItemClick($event)"
          (onItemContextMenu)="treeViewItemContextMenu($event)"
          width="100%"
        >
        </dx-tree-view>
      </div>
      <!-- 11.10.2026 sürüm satırı DaBNet logosunun altına; eski hâli:
      <div class="logo-area">
        <img src="assets/logo-dabnet.png" alt=""  width="120"  height="38"/>
        <img src="assets/logo-medium.png" alt="" width="45" height="45"/>
      </div>
      -->
      <!-- eski hâli (16.10.2026):
      <div class="logo-area">
        <div class="logo-dabnet">
          <img src="assets/logo-dabnet.png" alt=""  width="120"  height="38"/>
          <span *ngIf="surum && !compactMode" class="surum" [title]="'Sürüm ' + surum">{{ surum }}</span>
        </div>
        <img src="assets/logo-medium.png" alt="" width="45" height="45"/>
      </div>
      -->
      <!-- 16.10.2026 daraltılmışken yalnız logonun yazısız "dB" işareti (logo-isaret kırpar); belediye logosu ve sürüm gizli -->
      <div class="logo-area" [class.logo-dar]="compactMode">
        <div class="logo-dabnet" [title]="compactMode ? 'DaBNet' + (surum ? ' · ' + surum : '') : ''">
          <span class="logo-isaret"><img src="assets/logo-dabnet.png" alt=""  width="120"  height="38"/></span>
          <span *ngIf="surum && !compactMode" class="surum" [title]="'Sürüm ' + surum">{{ surum }}</span>
        </div>
        <img *ngIf="!compactMode" src="assets/logo-medium.png" alt="" width="45" height="45"/>
      </div>
      <dx-context-menu
        *ngIf="menuType !== 'Module' && menuType !== 'Branch'"
        [dataSource]="menuItems"
        target="#treeview .dx-treeview-item"
        (onItemClick)="contextMenuItemClick($event)"
      >
      </dx-context-menu>
    </div>
  </dx-resizable>
<!-- Kabuk canlandırma (02.10.2026): eski hâli
<dx-popover
  target="#modules-show"
  showEvent="click"
  position="top"
  [width]="450"
  color="red"
  [visible]="crudShowModule"
>
-->
<dx-popover
  target="#modules-show"
  showEvent="click"
  position="bottom"
  [width]="660"
  [wrapperAttr]="{ class: 'dk-moduller-popover' }"
  [visible]="crudShowModule"
  (onShown)="moduller.odakla()"
  (onHidden)="crudShowModule = false"
>
  <dk-modules #moduller (closePopover)="closedPopover($event)"></dk-modules>
</dx-popover>

<!-- <ng-content select="app-footer"></ng-content> -->
